import { useTranslationStore } from '@src/stores-v2/StoreContext';
import { useEffect } from 'react';

/**
 * Subscribe a view's language-selection state to `TranslationStore`
 * removal events. When the active language is the one being removed,
 * `onFallback` runs synchronously inside the store's removal action so
 * the parent's selection reset and the cache eviction land in the same
 * tick — the next render shows the source-language view instead of an
 * empty translated view.
 *
 * The `Transcript` component's existing `useLayoutEffect` handles
 * cursor-Y preservation across the language flip via the same
 * lock-restore path used for the redline / translated toggles, so no
 * additional cursor logic is needed here.
 */
export function useLanguageRemovalFallback(
  activeLanguage: string | null,
  onFallback: () => void,
): void {
  const translationStore = useTranslationStore();
  useEffect(() => {
    return translationStore.onLanguageRemoved(removed => {
      if (removed === activeLanguage) onFallback();
    });
  }, [activeLanguage, onFallback, translationStore]);
}
